/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { PreconstructionBuildTimesDto } from '../dto';

export const PreconstructionBuildTimesMapper = entity<PreconstructionBuildTimesDto>({});
